import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { BabylonGeoRecordModel } from '@/vue3/api/models';

export const useBabylonService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getAllBabylonGeoRecordModel = async (
        courseSchemaId: number,
    ): Promise<BabylonGeoRecordModel[]> => {
        const res = await axios.get(
            `${apiUrl}/babylon/geo-record-model/course/${courseSchemaId}`,
        );
        return res.data;
    };

    return {
        getAllBabylonGeoRecordModel,
    };
};
